import { render } from "./BaseTextArea.vue?vue&type=template&id=1cd8a160&ts=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=ts"
export * from "./BaseTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__